import React from "react";
import { AlertTriangle, Info, Lock } from "lucide-react";
import { useAccountStatus } from "../hooks/useAccountStatus";

const TONES = {
  info: {
    icon: Info,
    wrapper: "bg-sky-50 border-sky-100",
    iconColor: "text-sky-600",
    title: "text-sky-900",
    body: "text-sky-800/80",
  },
  warning: {
    icon: AlertTriangle,
    wrapper: "bg-amber-50 border-amber-100",
    iconColor: "text-amber-600",
    title: "text-amber-900",
    body: "text-amber-800/80",
  },
  closed: {
    icon: Lock,
    wrapper: "bg-slate-100 border-slate-200",
    iconColor: "text-slate-600",
    title: "text-slate-900",
    body: "text-slate-700/80",
  },
};

/**
 * Tells a restricted customer what state their account is in and what they can
 * still do.
 *
 * Renders nothing for an active account. Before this existed, an admin
 * suspending an account produced no visible change for the customer at all -
 * they saw a normal dashboard and only discovered the restriction when an
 * action failed with a 403.
 */
export function AccountStatusBanner({ className = "" }) {
  const { notice } = useAccountStatus();

  if (!notice) return null;

  const tone = TONES[notice.tone] ?? TONES.info;
  const Icon = tone.icon;

  return (
    <div
      role="status"
      className={`flex items-start gap-3 rounded-2xl border p-4 ${tone.wrapper} ${className}`}
    >
      <Icon size={18} className={`${tone.iconColor} shrink-0 mt-0.5`} />
      <div className="min-w-0">
        <p className={`text-sm font-semibold ${tone.title}`}>{notice.title}</p>
        <p className={`text-sm mt-0.5 leading-relaxed ${tone.body}`}>{notice.body}</p>
      </div>
    </div>
  );
}
